var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "UpdateUserModal",
            size: "lg",
            "content-class": "sub-menu-bg-blue-transparent uum-modal",
            title: "Update User",
            "hide-footer": "",
          },
          on: {
            shown: function ($event) {
              return _vm.initModal()
            },
            hidden: function ($event) {
              _vm.form.password = null
            },
          },
        },
        [
          _vm.user.role != "USHR Acquisition Admin"
            ? _c("div", { staticClass: "uum-back-row" }, [
                _c(
                  "a",
                  {
                    staticClass: "uum-back-link",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        return _vm.back()
                      },
                    },
                  },
                  [_vm._v("Back To User Accounts")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "mm-form" }, [
            _c("div", { staticClass: "mm-field" }, [
              _c("label", { staticClass: "mm-label" }, [_vm._v("Name *")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.name,
                    expression: "form.name",
                  },
                ],
                staticClass: "mm-input",
                attrs: { placeholder: "Enter name" },
                domProps: { value: _vm.form.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "name", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mm-field" }, [
              _c("label", { staticClass: "mm-label" }, [_vm._v("Email *")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.email,
                    expression: "form.email",
                  },
                ],
                staticClass: "mm-input",
                attrs: { placeholder: "Enter email" },
                domProps: { value: _vm.form.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "email", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mm-field" }, [
              _c("label", { staticClass: "mm-label" }, [
                _vm._v("Organization *"),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.org,
                      expression: "form.org",
                    },
                  ],
                  staticClass: "mm-input mm-select",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "org",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "" }, domProps: { value: null } },
                    [_vm._v("Select organization...")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.organizations, function (org) {
                    return _c(
                      "option",
                      { key: org.id, domProps: { value: org.id } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(org.company_name) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mm-field" }, [
              _c("label", { staticClass: "mm-label" }, [
                _vm._v("Authorization *"),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.authorization,
                      expression: "form.authorization",
                    },
                  ],
                  staticClass: "mm-input mm-select",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "authorization",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "" }, domProps: { value: null } },
                    [_vm._v("Select authorization...")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.permissions, function (obj) {
                    return _c(
                      "option",
                      { key: obj.id, domProps: { value: obj } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(obj.role_name) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mm-field" }, [
              _c("label", { staticClass: "mm-label" }, [_vm._v("Group *")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.group,
                      expression: "form.group",
                    },
                  ],
                  staticClass: "mm-input mm-select",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "group",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "" }, domProps: { value: null } },
                    [_vm._v("Select group...")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.groups, function (obj) {
                    return _c(
                      "option",
                      { key: obj.id, domProps: { value: obj.group_name } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(obj.group_name) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mm-field" }, [
              _c("label", { staticClass: "uum-checkbox-label" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.changePassword,
                      expression: "changePassword",
                    },
                  ],
                  staticClass: "uum-checkbox",
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.changePassword)
                      ? _vm._i(_vm.changePassword, null) > -1
                      : _vm.changePassword,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.changePassword,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.changePassword = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.changePassword = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.changePassword = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "uum-checkbox-custom" }),
                _vm._v(" "),
                _c("span", { staticClass: "uum-checkbox-text" }, [
                  _vm._v("Change Password"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.changePassword
              ? _c("div", { staticClass: "mm-field" }, [
                  _c("label", { staticClass: "mm-label" }, [
                    _vm._v("Password *"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.password,
                        expression: "form.password",
                      },
                    ],
                    staticClass: "mm-input",
                    attrs: {
                      type: "text",
                      name: "password",
                      placeholder: "Password",
                      autocomplete: "off",
                    },
                    domProps: { value: _vm.form.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "password", $event.target.value)
                      },
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.changePassword
              ? _c("div", { staticClass: "uum-note" }, [
                  _vm._v(
                    "\n        Note: You can edit or paste your own password.\n      "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.formSubmitErrors.length
            ? _c(
                "div",
                { staticClass: "uum-errors" },
                _vm._l(_vm.formSubmitErrors, function (error) {
                  return _c(
                    "div",
                    { key: error, staticClass: "alert alert-danger" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.submitSuccess
            ? _c("div", { staticClass: "uum-success" }, [
                _c("span", { staticClass: "alert alert-success" }, [
                  _vm._v(_vm._s(_vm.submitSuccess)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mm-actions uum-actions" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary", size: "sm" },
                  on: {
                    click: function ($event) {
                      return _vm.back()
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", size: "sm" },
                  on: {
                    click: function ($event) {
                      return _vm.checkForm()
                    },
                  },
                },
                [_vm._v("Update")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }